import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useStyles = makeStyles({
    cell: {
        position: 'relative',
        margin: px(0),
        padding: px(0),
        backgroundColor: tokens.colorNeutralBackground1,
        userSelect: 'none',
        pointerEvents: 'none',
        ...shorthands.borderColor(tokens.colorTransparentBackground),
    },
});
